var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tag',{staticClass:"balance-tag",attrs:{"type":"is-dark","size":"is-medium"}},[_vm._v(" Transferable: "),_c('Money',{attrs:{"value":_vm.currentBalance,"inline":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }